"use client";

import { useState } from "react";
import { useServerInsertedHTML } from "next/navigation";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

export const EmotionRegistry = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [cache] = useState(() => {
    const c = createCache({ key: "css" });
    c.compat = true;
    return c;
  });

  useServerInsertedHTML(() => {
    const entries = (cache as unknown as { inserted: Record<string, string> })
      .inserted;
    if (!entries || Object.keys(entries).length === 0) return null;

    const styles = Object.values(entries).join(" ");
    const dataEmotionAttribute = `${cache.key} ${Object.keys(entries).join(" ")}`;

    // Clear inserted so they're not re-emitted
    (cache as unknown as { inserted: Record<string, string> }).inserted = {};

    return (
      <style
        key={cache.key}
        data-emotion={dataEmotionAttribute}
        dangerouslySetInnerHTML={{ __html: styles }}
      />
    );
  });

  return <CacheProvider value={cache}>{children}</CacheProvider>;
};
